import axios from 'axios'

/**
 * Проверка авторизации
 */
export function isAuthenticated() {
  const token = localStorage.getItem('auth_token')
  return !!token
}

/**
 * Получение токена
 */
export function getToken() {
  return localStorage.getItem('auth_token')
}

/**
 * Получение данных пользователя
 */
export function getUser() {
  const userStr = localStorage.getItem('user')
  return userStr ? JSON.parse(userStr) : null
}

/**
 * Выход из системы
 */
export function logout() {
  localStorage.removeItem('auth_token')
  localStorage.removeItem('user')
  delete axios.defaults.headers.common['Authorization']
}

/**
 * Инициализация axios с токеном
 */
export function initializeAuth() {
  const token = getToken()
  if (token) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
  }

  // Interceptor для обработки 401 ошибок
  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response?.status === 401) {
        // Токен невалиден, выходим
        logout()
        window.location.href = '/login'
      }
      return Promise.reject(error)
    }
  )
}
